import React, { Fragment } from 'react';
import Helmet from 'react-helmet';

import NewsList from './NewsList/NewsList';
import ImagePanel from '@components/ImagePanel/ImagePanel';
import CloudPanel from '@components/CloudPanel/CloudPanel';
import ScrollContainer from '@components/ScrollContainer/ScrollContainer';

import newsData from './newsData';
import ImportImages from '@src/importImages';

const interiorMan = ImportImages('/slider/bkg1.jpg');

const News = () => {
  const height = window.innerHeight;
  const isMobile = window.innerWidth < 992;

  const scrollContainerProps = {
    pageHeight: height,
    autoScroll: {
      active: 1,
      delay: 1000
    }
  };

  return (
    <Fragment>
      <Helmet>
        <title>News | JetSuite</title>
        <meta name="description" content={'JetSuite News.'} />
      </Helmet>
      <ScrollContainer {...scrollContainerProps}>
        <ImagePanel
          id={'news-imagepanel'}
          screenHeight={height}
          image={interiorMan}
          alt={'Interior'}
          jsiClass={'d-none'}
        />
        <CloudPanel
          id={'news-cloudpanel'}
          hideJSILogo={true}
          screenHeight={height}
        >
          <NewsList id={'news-items'} newsData={newsData} isMobile={isMobile} />
        </CloudPanel>
      </ScrollContainer>
    </Fragment>
  );
};

export default News;



// WEBPACK FOOTER //
// ./src/components/News/News.jsx